import {
    SENDING_EMAIL,
    SEND_EMAIL_DONE,
    SEND_EMAIL_FAIL,
    OPEN_MODAL_EMAIL,
    CLOSE_MODAL_EMAIL,
    CHANGE_EMAIL_MODAL_ATTR,
    OPEN_COMPARISON_ACCORDION,
    CHANGE_EMAIL_COLLAPSE_ATTR,
    FETCH_COMPARISON_PRODUCTS_COVERAGE,
    OPEN_MODAL_QUOTATION_DATE_WARNING,
    CLOSE_MODAL_QUOTATION_DATE_WARNING,
    SET_USER_DETAILS,
    GET_INFOS_PROSPECT,
    OPEN_MODAL_QUOTATION_DATE_YEAR,
    CLOSE_MODAL_QUOTATION_DATE_YEAR,
} from './actionTypes'

export const fetchComparisonProductsCoverage = (plansInfo) => ({
    type: FETCH_COMPARISON_PRODUCTS_COVERAGE,
    plansInfo
})

export const openComparisonAccordion = (code) => ({
    type: OPEN_COMPARISON_ACCORDION,
    code
})

export const sendingEmail = () => ({
    type: SENDING_EMAIL,
    status: 'sending',
})

export const sendEmailDone = () => ({
    type: SEND_EMAIL_DONE,
    status: 'done'
})

export const sendEmailFail = () => ({
    type: SEND_EMAIL_FAIL,
    status: 'fail'
})

export const openModalEmail = () => ({
    type: OPEN_MODAL_EMAIL
})

export const closeModalEmail = () => ({
    type: CLOSE_MODAL_EMAIL
})

export const changeEmailModalAttr = ({ name, value }) => ({
    type: CHANGE_EMAIL_MODAL_ATTR,
    name,
    value,
})

export const changeEmailCollapseAttr = ({ name, value }) => ({
    type: CHANGE_EMAIL_COLLAPSE_ATTR,
    name,
    value,
})

export const openModalQuotationDateWarning = () => ({
    type: OPEN_MODAL_QUOTATION_DATE_WARNING
})

export const closeModalQuotationDateWarning = () => ({
    type: CLOSE_MODAL_QUOTATION_DATE_WARNING
})

export const setUserDetails = (data) => ({
    type: SET_USER_DETAILS,
    userDetails: data.user_details,
})

export const setInfosProspect = (infos) => ({
    type: GET_INFOS_PROSPECT,
    infos,
})

export const openModalQuotationDateYear = () => ({
    type: OPEN_MODAL_QUOTATION_DATE_YEAR
})

export const closeModalQuotationDateYear = () => ({
    type: CLOSE_MODAL_QUOTATION_DATE_YEAR
})


// WEBPACK FOOTER //
// ./src/actions/comparisonActions.js